<template>
  <div>
    <div class="with-margin">
      <router-link class="back" to="/"
        ><img alt="Back" src="@/assets/images/back.svg"
      /></router-link>
      <h1>#Realpeopleofclariant</h1>
    </div>
    <div id="slider">
      <slick :options="slickOptions" ref="slick">
        <img
          :key="index"
          :src="require('../assets/images/realpeopleofclariant/' + image)"
          style="max-width: 506px; height: 506px; margin: 0 24px;"
          v-for="(image, index) in this.getForSlider()"
        />
      </slick>
    </div>
    <div
      class="with-margin"
      style="margin-top: 98px; overflow-y: scroll; height: 852px; padding-bottom: 220px;"
    >
      <div class="flex flex-wrap" style="margin: -10px">
        <div
          :key="index"
          class="w-1/3"
          style="padding: 10px"
          v-for="(image, index) in this.getForGrid()"
        >
          <img
            :src="require('../assets/images/realpeopleofclariant/' + image)"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<style>
@import "~slick-carousel/slick/slick.css";
@import "~slick-carousel/slick/slick-theme.css";

/* slick */
#slider .slick-initialized img {
  visibility: visible;
}

#slider img {
  visibility: hidden;
}

#slider .slick-dots li button:before {
  display: none;
}

#slider .slick-dots li button {
  width: 16px;
  height: 16px;
  border-radius: 10px;
  background: transparent;
  border: 1px solid #fff;
}

#slider .slick-dots li.slick-active button {
  background: #fff;
}

#slider .slick-next:before,
#slider .slick-prev:before {
  display: none;
}

#slider .slick-prev,
#slider .slick-next {
  background: transparent url("../assets/images/btn-prev.png");
  position: absolute;
  width: 32px;
  height: 32px;
  top: auto;
  bottom: -56px;
  -webkit-transform: none;
  transform: none;
  z-index: 9;
}

#slider .slick-next {
  right: 434px;
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}

#slider .slick-prev {
  left: 434px;
}

#slider .slick-dots {
  bottom: -54px;
}

#slider .slick-dots li {
  width: 16px;
  height: 16px;
  margin: 0 12px;
}
</style>
<script>
import Slick from "vue-slick";

export default {
  components: { Slick },

  data() {
    return {
      slickOptions: {
        arrows: true,
        dots: true,
        centerMode: true,
        centerPadding: "263px",
        slidesToShow: 1,
        initialSlide: 1,
        infinite: true
      },
      index: Math.random(),
      images: [
        "AdrianInsta_Final.jpg",
        "AgaInsta_Final.jpg",
        "AlekInsta_Final.jpg",
        "andreinsta.jpg",
        "AnnaiInsta_Final.jpg",
        "AsiaGInsta_Final.jpg",
        "asiainsta.jpg",
        "AsiaZInsta_final.jpg",
        "bereniceinsta.jpg",
        "DomiInsta_Final.jpg",
        "gloriainsta.jpg",
        "julianinsta.jpg",
        "JustynaiInsta_Final.jpg",
        "karolinainsta.jpg",
        "kasiainsta.jpg",
        "KonrInsta_final.jpg",
        "mateuszinsta.jpg",
        "mencelinsta.jpg",
        "ozimkiewiczinsta.jpg",
        "RenataInsta_Final.jpg",
        "RodriInsta_Final.jpg"
      ]
    };
  },
  methods: {
    getForSlider() {
      let sliceIndex = this.sliceIndex;
      return this.images.filter(function(value, index) {
        return index >= sliceIndex && index < sliceIndex + 3;
      });
    },
    getForGrid() {
      let self = this;
      return this.images.filter(function(value) {
        return self.getForSlider().indexOf(value) < 0;
      });
    }
  },
  computed: {
    sliceIndex: function() {
      return Math.floor(this.index * (this.images.length - 3)) + 1;
    }
  }
};
</script>
